module.exports = __webpack_public_path__ + "static/media/BBStandLogo.61c47bea.svg";